import React from 'react';
import { Link } from 'react-router-dom';
import './Dropdown.css';
import { usePermissoes } from '../utils/PermissoesContext';

export default function DropdownVendas({ onLinkClick }) {
  const { temPermissao } = usePermissoes();
  
  return (
    <div className="dropdown-submenu-content">
      {temPermissao('VendasProdutos') && <Link to="/sidebar/VendasProdutosDropdown" onClick={onLinkClick}>Vendas de Produtos</Link>}
      {temPermissao('Vendas') && <Link to="/sidebar/VendasDropdown" onClick={onLinkClick}>Vendas de Serviços</Link>}
    </div>
  );
}
